export default __webpack_public_path__ + "static/media/reportingSquare.ca82856e.svg";